import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PdExpense from "./PdExpense";
import PdCheckpoint from "./PdCheckpoint";
import PdIncome from "./PdIncome";
import PdReference from "./PdReference";
import { Button } from "bootstrap";
import { ArrowLeftOutlined } from '@ant-design/icons';
import "./msinlayoutprofile.css"

const MainLayoutProfile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [navigateData, setNavigateData] = useState(location.state);

  useEffect(() => {
    if (!navigateData) {
      const savedData = sessionStorage.getItem("buisnessPd");
      if (savedData) {
        setNavigateData(JSON.parse(savedData));
      }
    }
  }, [navigateData]);

  const handleBack = () => {
    if (navigateData) {
      const queryParams = new URLSearchParams(navigateData).toString();
      const targetPath = `/buisness-pd/add?${queryParams}`;

      // Check if the current path is already the target path
      if (location.pathname + location.search !== targetPath) {
        navigate(targetPath, { replace: true });
      }
    } else {
      navigate(-2); // Go back without data if navigateData is not available
    }
  };

  if (!navigateData) {
    return <div>Loading...</div>;
  }

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
      <button type="primary" icon={<ArrowLeftOutlined />} className="custom-back-button mb-3" onClick={handleBack}>
      Back
    </button>

        <div className="col-md-12">
          <div className="card bg-white">
            <div className="card-body">
              <ul className="nav nav-tabs nav-tabs-top nav-justified">
                <li className="nav-item">
                  <Link
                    className="nav-link active"
                    to="#top-justified-tab1"
                    data-bs-toggle="tab"
                  >
                    Income
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="#top-justified-tab2"
                    data-bs-toggle="tab"
                  >
                    Expense
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="#top-justified-tab3"
                    data-bs-toggle="tab"
                  >
                    CheckPoints
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="#top-justified-tab4"
                    data-bs-toggle="tab"
                  >
                    Reference
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="#top-justified-tab5"
                    data-bs-toggle="tab"
                  >
                    Documents
                  </Link>
                </li>
              </ul>
              <div className="tab-content">
                <div className="tab-pane show active" id="top-justified-tab1">
                  <PdIncome
                    ProfileId={navigateData?.ProfileId}
                    commingIds={navigateData}
                    profileId={navigateData?.BusinessPdProfileId}
                  />
                </div>
                <div className="tab-pane" id="top-justified-tab2">
                  <PdExpense profileId={navigateData?.BusinessPdProfileId} />
                </div>
                <div className="tab-pane" id="top-justified-tab3">
                  <PdCheckpoint
                    ProfileId={navigateData?.ProfileId}
                    commingIds={navigateData}
                    profileId={navigateData?.BusinessPdProfileId}
                  />
                </div>
                <div className="tab-pane" id="top-justified-tab4">
                  <PdReference
                    ProfileId={navigateData?.ProfileId}
                    commingIds={navigateData}
                    profileId={navigateData?.BusinessPdProfileId}
                  />
                </div>
                <div className="tab-pane" id="top-justified-tab5">
                  {/* Content for Documents tab */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainLayoutProfile;